import { handleResponse } from './handleresponse'
import { apiurl } from '@/services/config'
const API_URL = apiurl

export const ProductServices = {
  getProductMapping,
  getBrands,
  getBrandsByid,
  getProductCategory,
  deleteProductMapping,
  getSupplier,
  getSupplierGold,
  getSellerProducts,
  addProductmapping,
  updateProductmapping,
  getBestHit,
  getProcuctPricingByBrand,
  getProcuctPricingByProductId,
  getProcuctByBrandId,
  cariSeller,
  getProcuctPricingCari,
  getmysupplier
}

function getmysupplier () {
  return fetch(API_URL + '/api/v1/mysupplier', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function cariSeller (nama) {
  return fetch(API_URL + '/api/v1/supplier/cari?cari=' + nama, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getProcuctByBrandId (brandid) {
  return fetch(API_URL + '/api/v1/product/bybrand/' + brandid, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getProcuctPricingByProductId (productid) {
  var sort = 'saleprice'
  var sorder = 'DESC'
  const a = localStorage.getItem('sortpriceproduk')
  console.log(a)
  if (a === '1') {
    sorder = 'ASC'
  } else {
    sorder = 'DESC'
  }
  const sorting = sort + ',' + sorder
  return fetch(API_URL + '/api/v1/product/pricing/byprodid/' + productid + '?size=50&sort=' + sorting, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getProcuctPricingCari (cari) {
  var sort = 'saleprice'
  var sorder = 'DESC'
  const a = localStorage.getItem('sortpriceproduk')
  if (a === '1') {
    sorder = 'ASC'
  } else {
    sorder = 'DESC'
  }
  const sorting = sort + ',' + sorder
  return fetch(API_URL + '/api/v1/product/pricing/cari?cari=' + cari + '&size=50&sort=' + sorting, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getProcuctPricingByBrand (brandid) {
  var sort = 'saleprice'
  var sorder = 'DESC'
  const a = localStorage.getItem('sortpriceproduk')
  if (a === '1') {
    sorder = 'ASC'
  } else {
    sorder = 'DESC'
  }
  const sorting = sort + ',' + sorder
  return fetch(API_URL + '/api/v1/product/pricing/bybrand/' + brandid + '?size=25&sort=' + sorting, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getBestHit () {
  return fetch(API_URL + '/api/v1/supplier/besthit', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getSellerProducts (id) {
  return fetch(API_URL + '/api/v1/product/seller/' + id, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getSupplierGold () {
  return fetch(API_URL + '/api/v1/supplier/gold?size=6', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getSupplier () {
  return fetch(API_URL + '/api/v1/supplier?size=50&sort=sellerid,RAND()', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getBrands () {
  return fetch(API_URL + '/api/v1/product/brands', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getBrandsByid (id) {
  return fetch(API_URL + '/api/v1/product/brand/' + id, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getProductCategory () {
  return fetch(API_URL + '/api/v1/product/category', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function updateProductmapping (postdata) {
  return fetch(API_URL + '/api/v1/product/mapping/' + postdata.id + '/' + postdata.status, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function addProductmapping (postdata) {
  return fetch(API_URL + '/api/v1/product/mapping', {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function deleteProductMapping (id) {
  return fetch(API_URL + '/api/v1/product/mapping/' + id, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getProductMapping (opt) {
  console.log(opt)
  var sort = 'id'
  var sorder = 'DESC'
  if (opt.sortBy) {
    console.log(opt.sortBy)
    sort = opt.sortBy[0]
    if (typeof sort === 'undefined') {
      sort = localStorage.getItem('mappingsortby')
    } else {
      localStorage.setItem('mappingsortby', sort)
    }
  }
  if (opt.sortDesc) {
    if (opt.sortDesc[0]) {
      sorder = 'DESC'
    }
  }
  if (opt.itemsPerPage < 0) {
    opt.itemsPerPage = 10000
  }

  if (!opt.search) {
    opt.search = ''
  }

  if (typeof opt.sellerid === 'undefined' || opt.sellerid === null) {
    opt.sellerid = ''
  }

  const page = opt.page - 1
  const sorting = sort + ',' + sorder
  if (opt.categoryid === undefined || opt.categoryid === null) {
    opt.categoryid = ''
  }
  if (opt.brandid === undefined || opt.brandid === null) {
    opt.brandid = ''
  }
  return fetch(API_URL + '/api/v1/product/mappings?search=' + opt.search + '&brandid=' + opt.brandid + '&categoryid=' + opt.categoryid + '&sellerid=' + opt.sellerid + '&page=' + page + '&size=' + opt.itemsPerPage + '&sort=' + sorting, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
